// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AryVW","col":"styles_col__1DPig"};